import React from 'react';

import { Html } from '../Html';
import { Container } from '../Containers';
import { MenuPart } from './MenuPart';
import { tablet, desktopMedium, minWidth } from '../../screenSizes';
import { largeMargin, gutter } from '../../margins';

export const Menu = ({ description, parts }) => [
  <Container
    key="menu-content"
    css={`
      display: flex;
      align-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
    `}
  >
    <div
      css={`
        width: 100%;
        margin-bottom: ${largeMargin};
      `}
    >
      <Html html={description} />
    </div>
    {parts.map(menuPart => (
      <MenuPart
        css={`
          width: 100%;

          ${minWidth(tablet)} {
            max-width: calc(50% - (${gutter} * 2));
            margin-left: ${gutter};
            margin-right: ${gutter};

            &:nth-child(odd) {
              width: auto;
            }
          }

          ${minWidth(desktopMedium)} {
            max-width: calc(100%/3 - (${gutter} * 2));

            &:nth-child(3n) {
              width: auto;
            }
          }
        `}
        key={menuPart.subtitle}
        {...menuPart}
      />
    ))}
  </Container>,
];



// WEBPACK FOOTER //
// ./app/components/MenuSection/Menu.js